import { z } from "zod";
import type { Operation } from "../../types";

const pipelineSummary: Operation<
  void,
  { pipeline_id: number },
  void,
  {
    pipeline_id: number;
    stages: {
      stage_id: number;
      stage_name: string;
      count: number;
      total_minor: number;
      currency: string;
      weighted_minor: number;
    }[];
    forecast_minor_by_currency: Record<string, number>;
  }
> = {
  method: "GET",
  path: () => "/api/crm/reports/pipeline_summary",
  query: z.object({ pipeline_id: z.coerce.number().int() }),
  response: z.object({
    pipeline_id: z.number(),
    stages: z.array(
      z.object({
        stage_id: z.number(),
        stage_name: z.string(),
        count: z.number(),
        total_minor: z.number(),
        currency: z.string(),
        weighted_minor: z.number(),
      }),
    ),
    forecast_minor_by_currency: z.record(z.string(), z.number()),
  }),
};

const activitySummary: Operation<
  void,
  { date_after?: string; date_before?: string },
  void,
  {
    by_owner: {
      owner_actor_id: number | null;
      owner_label: string;
      calls: number;
      emails: number;
      sms: number;
      meetings: number;
      total: number;
    }[];
  }
> = {
  method: "GET",
  path: () => "/api/crm/reports/activity_summary",
  query: z
    .object({
      date_after: z.string().optional(),
      date_before: z.string().optional(),
    })
    .partial(),
  response: z.object({
    by_owner: z.array(
      z.object({
        owner_actor_id: z.number().nullable(),
        owner_label: z.string(),
        calls: z.number(),
        emails: z.number(),
        sms: z.number(),
        meetings: z.number(),
        total: z.number(),
      }),
    ),
  }),
};

const funnelSummary: Operation<
  void,
  { date_after?: string; date_before?: string },
  void,
  {
    leads_created: number;
    opportunities_created: number;
    opportunities_won: number;
    lead_to_opp_pct: number;
    opp_to_won_pct: number;
  }
> = {
  method: "GET",
  path: () => "/api/crm/reports/funnel_summary",
  query: z
    .object({
      date_after: z.string().optional(),
      date_before: z.string().optional(),
    })
    .partial(),
  response: z.object({
    leads_created: z.number(),
    opportunities_created: z.number(),
    opportunities_won: z.number(),
    lead_to_opp_pct: z.number(),
    opp_to_won_pct: z.number(),
  }),
};

export const reports = {
  pipeline_summary: pipelineSummary,
  activity_summary: activitySummary,
  funnel_summary: funnelSummary,
};
